import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { TransactionService } from 'src/app/services/transaction/transaction.service';
import { UserService } from 'src/app/services/user/user.service';
import { User } from './../../services/user/model/user';
import { ModalDetailsIndicatedComponent } from './modal-details-indicated/modal-details-indicated.component';

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.page.html',
  styleUrls: ['./wallet.page.scss'],
})
export class WalletPage {
  public user: User;
  public selectTabs = 'balance';
  public showBalance = true;
  public loading = true;
  updateCredits = false;

  constructor(
    private loaderService: LoaderService,
    private modalCtrl: ModalController,
    private router: Router,
    private userService: UserService,
    private transactionService: TransactionService
  ) {}

  async ionViewWillEnter() {
    await this.loaderService.showLoader();
    this.loading = true;
    this.updateCredits = true;
    try {
      const [user, credits, indicateds, statements] = await Promise.all([
        this.userService.getUser(),
        this.transactionService.getCredits(),
        this.userService.getIndicateds(),
        this.userService.getStatements(),
      ]);
      this.user = user;
      this.user.credits = credits;
      this.user.indicateds = indicateds;
      this.user.statements = statements;
    } catch (error) {
      console.error(error);
    } finally {
      await this.loaderService.hideLoader();
      this.loading = false;
      this.updateCredits = false;
    }
  }

  async onRefreshPage(event) {
    this.updateCredits = true;
    try {
      const [user, credits, indicateds, statements] = await Promise.all([
        this.userService.getUser(),
        this.transactionService.getCredits(),
        this.userService.getIndicateds(),
        this.userService.getStatements(),
      ]);
      this.user = user;
      this.user.credits = credits;
      this.user.indicateds = indicateds;
      this.user.statements = statements;
    } catch (error) {
      console.error(error);
    } finally {
      this.updateCredits = false;
    }
    setTimeout(() => event.target.complete(), 2000);
  }

  async onClickDetails() {
    const modal = await this.modalCtrl.create({
      component: ModalDetailsIndicatedComponent,
    });
    await modal.present();
  }

  onClickPrime() {
    this.router.navigate(['home/feed/plans']);
  }

  onClickWithdraw() {
    this.router.navigate(['home/feed/withdraw']);
  }

  onClickAdd() {
    this.router.navigate(['home/wallet/add-credits']);
  }
}
